/**
 * WISHLIST PRODUCT QUANTITY
 * 
 * module de gestion des quantités
 * de produits dans la partie WL details
 */
import $ from "jquery";
const WLProductQuantity = (() => {
    const DOM_WISHLIST_PRODUCT_QUANTITY = '[data-js-quantity="input"]';
    
    /**
     * INIT (func)
     */
    const init = () => {
        // Changement de la quantité produit
        $(DOM_WISHLIST_PRODUCT_QUANTITY).off().on('change', (event) => {
            let qty = parseInt($(event.currentTarget).val());
            let productID = parseInt($(event.currentTarget).data('id'));
            qty = qty > 0 ? qty : 1;
            window.WL.setProductQuantity(productID, qty);
        });
    };
    return {init};
})();
export default WLProductQuantity;